/* ==========================================================================
   KASE ARTIST RESKIN 2026 - behaviour
   No dependencies. No framework. The live theme loads gsap, ScrollTrigger,
   three.js and Shery.js on every page including the product page, which is
   40 script tags for a shop that sells phone cases.

   Everything here degrades: the finder falls back to a rendered list of every
   model, the gallery falls back to a scroll rail, the accordions are native
   <details>. If this file fails to load the store still works and is still
   fully crawlable.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------- model finder */
  /* 152 products is small enough to ship the whole index inline and filter it
     on keystroke with no network call. That is the difference between a finder
     that feels instant on a 3G phone and one that does not. */

  function normalise(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function score(model, q) {
    // Rank so that "13" puts iPhone 13 above iPhone 13 Pro Max, and "a55"
    // finds Samsung A55. Lower is better.
    var name = model.n;
    var tokens = normalise(name).split(' ');
    var qn = normalise(q);
    if (!qn) return 9999;

    var joined = tokens.join(' ');
    if (joined === qn) return 0;

    // exact whole-token match, e.g. "13" against ["iphone","13","case"]
    if (tokens.indexOf(qn) !== -1) return 1 + tokens.length * 0.01;

    // starts with the query
    if (joined.indexOf(qn) === 0) return 2 + tokens.length * 0.01;

    // any token starts with the query, e.g. "a5" -> "a55"
    for (var i = 0; i < tokens.length; i++) {
      if (tokens[i].indexOf(qn) === 0) return 3 + i * 0.1 + tokens.length * 0.01;
    }

    // substring anywhere
    if (joined.indexOf(qn) !== -1) return 5 + tokens.length * 0.01;

    // every word of a multi-word query appears somewhere: "s24 ultra"
    var parts = qn.split(' ');
    if (parts.length > 1) {
      var all = parts.every(function (p) { return joined.indexOf(p) !== -1; });
      if (all) return 4 + tokens.length * 0.01;
    }
    return Infinity;
  }

  function initFinder(root) {
    var input = $('.ka-finder__input', root);
    var results = $('.ka-finder__results', root);
    var meta = $('.ka-finder__meta', root);
    var clear = $('.ka-finder__clear', root);
    var dataEl = $('#ka-model-data');
    if (!input || !results || !dataEl) return;

    var models;
    try { models = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!models || !models.length) return;

    var TICK = '<svg class="ka-result__tick" viewBox="0 0 20 20" width="17" height="17" aria-hidden="true"><path fill="currentColor" d="M7.6 14.3 3.7 10.4l1.4-1.4 2.5 2.5 6.9-6.9 1.4 1.4z"/></svg>';
    var active = -1;
    var shown = [];

    function render(list, q) {
      if (!list.length) {
        results.innerHTML =
          '<div class="ka-finder__empty">' +
            '<p>We do not have <strong>' + escapeHtml(q) + '</strong> listed yet.</p>' +
            '<a class="ka-btn ka-btn--ghost" href="/pages/phone-models">See every phone we make cases for</a>' +
          '</div>';
        // A search that finds nothing is a customer naming a handset we should
        // stock. Worth capturing, nothing on the current site does.
        track('finder_no_result', { term: q });
        return;
      }
      var html = '';
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        var oos = !m.a;
        html +=
          '<a class="ka-result' + (oos ? ' ka-result--oos' : '') + '"' +
            ' href="/products/' + m.h + '"' +
            ' data-idx="' + i + '"' +
            '>' +
              '<span>' +
              '<span class="ka-result__name">' + escapeHtml(m.n) + '</span>' +
              '<span class="ka-result__price">' + m.p + '</span>' +
            '</span>' +
            (oos ? '<span class="ka-result__chip">Back soon</span>' : TICK) +
          '</a>';
      }
      results.innerHTML = html;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var debounce;
    function onInput() {
      var q = input.value.trim();
      root.classList.toggle('is-typing', q.length > 0);
      active = -1;
      if (!q) { results.innerHTML = ''; if (meta) meta.textContent = ''; return; }

      var scored = [];
      for (var i = 0; i < models.length; i++) {
        var s = score(models[i], q);
        if (s !== Infinity) scored.push({ m: models[i], s: s });
      }
      // in stock first, then by score, then by sales rank
      scored.sort(function (a, b) {
        if (a.m.a !== b.m.a) return a.m.a ? -1 : 1;
        if (a.s !== b.s) return a.s - b.s;
        return (a.m.r || 999) - (b.m.r || 999);
      });
      shown = scored.slice(0, 40).map(function (x) { return x.m; });
      render(shown, q);
      if (meta) {
        meta.textContent = shown.length
          ? shown.length + (shown.length === 1 ? ' model matches' : ' models match')
          : '';
      }
      clearTimeout(debounce);
      debounce = setTimeout(function () { track('finder_search', { term: q, results: shown.length }); }, 700);
    }

    input.addEventListener('input', onInput);

    // keyboard: down/up to walk results, enter to open the top one
    input.addEventListener('keydown', function (e) {
      var items = $$('.ka-result:not(.ka-result--oos)', results);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        active += e.key === 'ArrowDown' ? 1 : -1;
        if (active < 0) active = items.length - 1;
        if (active >= items.length) active = 0;
        items.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
        items[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        var target = items[active >= 0 ? active : 0];
        if (target) { e.preventDefault(); track('finder_result_click', { to: target.getAttribute('href') }); location.href = target.href; }
      } else if (e.key === 'Escape') {
        input.value = ''; onInput();
      }
    });

    results.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.ka-result') : null;
      if (a) track('finder_result_click', { to: a.getAttribute('href') });
    });

    if (clear) {
      clear.addEventListener('click', function () {
        input.value = ''; onInput(); input.focus();
      });
    }

    // chips prefill the search rather than navigating, so a tap shows the
    // match plus its neighbours instead of committing to one model
    $$('.ka-finder__chip', root).forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = chip.dataset.q || chip.textContent.trim();
        onInput();
        input.focus();
      });
    });
  }

  $$('.ka-finder').forEach(initFinder);

  /* ------------------------------------------------------- mobile sheet -- */
  /* The finder opens from the sticky bar as a full screen sheet so the field
     lands under the thumb instead of at the top of a scroll. */

  var sheet = $('#ka-finder-sheet');
  function openSheet() {
    if (!sheet) return;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var i = $('.ka-finder__input', sheet);
    // focus after the transition or iOS scrolls the page under the sheet
    setTimeout(function () { if (i) i.focus(); }, 300);
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  $$('[data-ka-open-finder]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openSheet(); });
  });
  if (sheet) {
    $$('[data-ka-close-sheet]', sheet).forEach(function (b) {
      b.addEventListener('click', closeSheet);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheet();
  });

  /* ------------------------------------------------------- sticky bars --- */
  /* Shown once the hero CTA has scrolled out of reach, so there is never a
     moment where the primary action is off screen. */

  function initStickyOn(barSel, sentinelSel) {
    var bar = $(barSel);
    var sentinel = $(sentinelSel);
    if (!bar || !sentinel) return;
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-shown'); return; }
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-shown', !entries[0].isIntersecting);
    }, { rootMargin: '-72px 0px 0px 0px' }).observe(sentinel);
  }
  initStickyOn('#ka-stickybar', '[data-ka-sticky-sentinel]');

  /* The PDP buy bar is NOT sentinel gated. It used to wait until the inline
     button had scrolled away, which was right while the page had two buttons.
     The inline one is hidden on mobile now, so gating the bar would leave the
     top of the page with no way to buy at all. It ships with `is-shown` on it
     from Liquid; this only reserves the space it covers. */
  if ($('#ka-stickybuy')) document.body.classList.add('ka-has-stickybuy');

  /* ------------------------------------------------------- nav drawer ---- */

  var drawer = $('#ka-drawer');
  var burger = $('#ka-burger');
  if (drawer && burger) {
    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    });
  }

  /* ------------------------------------------------------- pdp gallery --- */

  /* Both namings are accepted. The v2 rework renamed these, and this theme has
     already had the CDN serve a stale asset alongside a fresh one once, so a
     mismatched pair degrades to a plain scroll rail rather than to dots that
     do nothing when clicked. */
  var rail = $('[data-ka-pdp-rail]') || $('.ka-gallery__rail');
  var dots = $$('.kav2-pdp__dot');
  if (!dots.length) dots = $$('.ka-gallery__dot');
  if (rail && dots.length) {
    var slides = $$('.kav2-pdp__cell', rail);
    if (!slides.length) slides = $$('.ka-gallery__slide', rail);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.intersectionRatio > 0.6) {
            var i = slides.indexOf(en.target);
            dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
          }
        });
      }, { root: rail, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
  }

  /* ------------------------------------------------------- customiser ---- */
  /* The customiser is ColorPark. Fancy Product Designer is not in this theme,
     not as a fallback and not as an app embed, so there is no #fbd_button to
     forward to and nothing that can open over the page on load.

     ColorPark owns its own button inside <colorpark-customise> and binds to
     data-cp-* attributes, never to a class or an id. So the sticky mobile bar
     is a MIRROR: it forwards the click to the real ColorPark button and lets
     the component do the work. Forwarding beats duplicating, because the
     component holds the session, the warm preload and the abandon handling,
     and a second entry point would have none of them. */

  function cpButton() {
    return document.querySelector('colorpark-customise [data-cp-button]');
  }

  $$('[data-ka-customise]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var real = cpButton();
      if (real && real !== btn) {
        track('customiser_opened', { handle: btn.dataset.handle || null });
        real.click();
        return;
      }
      /* No ColorPark on this product, so this is an unmapped product such as
         the Gift Box. Submit the ordinary form rather than doing nothing,
         which is what a dead sticky button would look like to a shopper. */
      var form = document.querySelector('.ka-pdp form.form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  /* Variant cards. Two values only on this store, PrintGuard R299 and
     PrintGuard Mag R499.

     ColorPark reads the variant LIVE rather than at render time, by subscribing
     to Dawn's PUB_SUB_EVENTS.variantChange. This theme does not use Dawn's
     variant picker, so that event would never fire and every customised line
     would be created against whichever variant happened to render first. The
     R299 case would be sold at R299 while the shopper believed they had chosen
     PrintGuard Mag at R499.

     So the KA cards publish the event Dawn would have published. */
  var vInputs = $$('.ka-variant input[type=radio]');
  if (vInputs.length) {
    var hidden = $('.product-variant-id');
    /* An explicit hook, not the paragraph. This used to reach in and rewrite
       priceEl.firstChild.nodeValue, which silently required the price to be the
       paragraph's first TEXT node. Any markup around the number, a currency
       span or a sold out flag, and the wrong node gets rewritten or the price
       simply stops updating with no error anywhere. The fallback keeps an older
       cached template working. */
    var priceEl = $('[data-ka-price]') || $('.ka-pdp__price');
    var stickyBtn = $('#ka-stickybuy .ka-btn');
    var stickyBase = stickyBtn ? stickyBtn.textContent.split('\u00b7')[0].trim() : '';

    vInputs.forEach(function (i) {
      i.addEventListener('change', function () {
        if (!i.checked) return;
        if (hidden) hidden.value = i.value;
        if (priceEl && i.dataset.price) {
          if (priceEl.hasAttribute('data-ka-price')) priceEl.textContent = i.dataset.price;
          else if (priceEl.firstChild) priceEl.firstChild.nodeValue = i.dataset.price + ' ';
        }
        if (stickyBtn && i.dataset.price) stickyBtn.textContent = stickyBase + ' \u00b7 ' + i.dataset.price;

        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                variant: {
                  id: Number(i.value),
                  available: !i.disabled,
                  price: i.dataset.priceCents ? Number(i.dataset.priceCents) : undefined
                }
              }
            });
          }
        } catch (e) { /* never let reporting or wiring break the buy path */ }

        try {
          var u = new URL(location.href);
          u.searchParams.set('variant', i.value);
          history.replaceState({}, '', u);
        } catch (e) {}
      });
    });
  }

  /* ------------------------------------------------------- collection ---- */

  var more = $('#ka-loadmore');
  if (more) {
    more.addEventListener('click', function () {
      var hidden = $$('.ka-grid .ka-card[hidden]').slice(0, 24);
      hidden.forEach(function (c) { c.removeAttribute('hidden'); });
      if (!$$('.ka-grid .ka-card[hidden]').length) more.remove();
    });
  }

  /* ------------------------------------------------------- reporting ----- */
  /* Fire into whatever is present. The store has a Meta pixel via the
     Facebook channel, a TikTok pixel and GA4, and none of them currently see
     any step between landing and purchase. */

  function track(name, props) {
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: name }, props || {}));
      }
      if (window.gtag) window.gtag('event', name, props || {});
      if (window.ttq && window.ttq.track) window.ttq.track(name, props || {});
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, props || {});
      }
    } catch (e) { /* reporting must never break the page */ }
  }
  window.kaTrack = track;
})();
